import { ISidebarMenuButton } from "../interfaces/sidebar-modul.interface";

export class MenuHandler {
    private menu: HTMLUListElement;
    private button: HTMLButtonElement;

    constructor(private wrapper: HTMLElement) {
        this.button = this.createButton('wecdev-hamburger-btn fa-solid fa-bars');
        this.menu = this.createElement('ul', 'module-menu');
        this.menu.style.display = 'none';

        this.wrapper.append(this.button, this.menu);
        this.setupMenuToggle();
    }

    public initJqueryMenu(shadow: ShadowRoot): void {
        let menuElements: NodeListOf<HTMLUListElement> = shadow.querySelectorAll('.module-menu');
        menuElements.forEach(menuEl => {
            $(menuEl).menu();
        });

        this.checkMenu();
    }

    private checkMenu(): void {
        if (this.menu.children.length === 0) {
            this.button.style.display = 'none';
        } else {
            this.button.style.display = 'block';
        }
    }

    public addGroup(title: string, groupClass: string, iconClass: string): HTMLUListElement {
        let li = document.createElement('li');
        li.classList.add(groupClass);
        let div = document.createElement('div');
        div.innerHTML = `<span class="${iconClass}"></span>${title}`;

        let ul = document.createElement('ul');
        li.append(div, ul);
        this.menu.appendChild(li);

        return ul;
    }

    public addItem(parentUl: HTMLUListElement, title: string, iconClass: string, onClick: (e: MouseEvent) => void): void {
        let li = document.createElement('li');
        let div = document.createElement('div');
        div.innerHTML = `<span class="${iconClass}"></span>${title}`;

        li.appendChild(div);
        li.addEventListener('click', onClick);

        parentUl.appendChild(li);
    }

    public addModuleButtons(buttons: ISidebarMenuButton[], parentUl: HTMLUListElement = this.menu): void {
        buttons.forEach(btn => {
            this.addItem(parentUl, btn.title, btn.iconClass, btn.onClick);
        });
    }

    private setupMenuToggle(): void {
        this.button.addEventListener('click', e => {
            e.stopPropagation();
            this.menu.style.display = this.menu.style.display === 'block' ? 'none' : 'block';
        });
        document.addEventListener('click', () => {
            this.menu.style.display = 'none';
        });
    }

    private createButton(className: string, label: string = ''): HTMLButtonElement {
        let btn = document.createElement('button');
        btn.textContent = label;
        btn.className = className;

        return btn;
    }

    private createElement<K extends keyof HTMLElementTagNameMap>(tag: K, className?: string): HTMLElementTagNameMap[K] {
        let el = document.createElement(tag);
        if (className) {
            el.className = className;
        }

        return el;
    }
}
